export enum ROLE_ROUTE_NAMES {
  ROLE_INDEX = "role-index",
  ROLE_VIEW = "role-view",
  ACCESS_RULES_ROLE_VIEW = "access-rules-role-view",
  ACCESS_RULES_INDEX = "access-rules-index",
}
